(function () {
    var menuElements = document.querySelectorAll('#nav-menu-toggle, #nav');
    if (document.querySelector('#nav-menu-toggle')) {
        document.querySelector('#nav-menu-toggle').onclick = function () {
            for (var i = 0; i < menuElements.length; i++) {
                menuElements[i].classList.toggle('open');
            }
        }
    }

    document.querySelectorAll('.nav__toggle-icon').forEach(function (e) {
        e.onclick = function (e) {
            this.classList.toggle('open');
            this.nextElementSibling.classList.toggle('open');
        }
    });

    // Mobile 
    document.querySelectorAll(".nav__group-toggle").forEach(item => {
        item.addEventListener("click", () => {
            item.classList.toggle("open")
            item.nextElementSibling.classList.toggle("open")
        })
    })

    // Cookies
    var cookieButtons = document.querySelectorAll('.cookie-acceptance__button')
    if (cookieButtons != null) {
        for (var cookieButton of cookieButtons) {
            cookieButton.addEventListener('click', function () {
                document.getElementById('cookie-notice').classList.add('hidden')
                let formData = new FormData()
                formData.append('cookie', this.id)

                fetch('/scripts/cookie.php', {
                    method: 'POST',
                    body: formData
                })
            })
        }
    }

    // Search Autocomplete
    var controller = null
    var timeout = null
    var autocomplete = document.getElementById('search-autocomplete')

    document.getElementById('search__input').addEventListener('keyup', function (event) {
        if (event.code != ('Key' + event.key.toUpperCase()) && event.code != ('Digit' + event.key) && event.key != 'Backspace') {
            return
        }

        if (timeout != null) {
            clearTimeout(timeout)
        }

        if (controller != null) {
            controller.abort()
            controller = null
        }

        if (this.value == '') {
            autocomplete.querySelectorAll('.autocomplete-list__item').forEach(li => li.remove())
            autocomplete.classList.remove('active')
            return
        }

        timeout = setTimeout(() => {
            controller = new AbortController()

            const signal = controller.signal

            const formData = new FormData()
            formData.append('search', document.getElementById('search__input').value)

            autocomplete.classList.add('active')
            autocomplete.querySelector('.lds-ring').style.removeProperty('display')
            autocomplete.querySelector('.autocomplete-list').style.display = 'none'

            autocomplete.querySelector('.autocomplete-list').innerHTML = ''

            fetch("/scripts/search-autocomplete.php", {
                method: "POST",
                body: formData,
                signal: signal
            }).then(res => res.json()).then(data => {
                controller = null

                autocomplete.querySelector('.autocomplete-list').style.removeProperty('display')
                autocomplete.querySelector('.lds-ring').style.display = 'none'

                data.forEach(product => {
                    var li = document.createElement('a')
                    var a = document.createElement('a')
                    li.href = a.href = product.url
                    li.classList.add('autocomplete-list__item')
                    a.innerHTML = product.title
                    li.tabIndex = -1

                    var img = document.createElement('img')
                    if (product.meta != undefined && product.meta.product_image != undefined && product.meta.product_image.thumbnail != undefined) {
                        img.src = product.meta.product_image.thumbnail
                        img.alt = product.meta.product_image.thumbnail
                    } else {
                        img.src = '/images/fallback/product.jpg'
                        img.alt = 'Fallback Image'
                    }
                    li.append(img)
                    li.append(a)
                    autocomplete.querySelector('.autocomplete-list').append(li)
                })

                if (data.length == 0) {
                    autocomplete.classList.remove('active')
                }
            }).catch(error => {

            })
        }, 1000)
    })

    // Listen for up and down keys
    document.addEventListener('keyup', function (e) {
        if (e.key == 'ArrowDown' && autocomplete.classList.contains('active')) {
            if (document.activeElement == document.getElementById('search__input')) {
                document.querySelector('.autocomplete-list__item').focus()
            } else if (document.activeElement.classList.contains('autocomplete-list__item') && document.activeElement.nextElementSibling != null) {
                document.activeElement.nextElementSibling.focus()
            }
        } else if (e.key == 'ArrowUp' && autocomplete.classList.contains('active')) {
            if (document.activeElement == document.querySelector('.autocomplete-list__item')) {
                document.getElementById('search__input').focus()
                document.getElementById('search__input').setSelectionRange(-1, -1)
            } else if (document.activeElement.classList.contains('autocomplete-list__item')) {
                document.activeElement.previousElementSibling.focus()
            }
        }
    })

    // Listen for enter key
    document.addEventListener('keypress', function (e) {
        if (e.key === 'Enter' && document.activeElement.classList.contains('autocomplete-list__item')) {
            e.preventDefault()
            document.activeElement.querySelector('a').click()
        }
    })

    // Hide autocomplete
    document.getElementById('search__input').addEventListener('blur', function () {
        setTimeout(() => {
            if (!document.activeElement.classList.contains('autocomplete-list__item')) {
                autocomplete.classList.remove('active')
            }
        }, 100)
    })

    document.addEventListener('click', function () {
        setTimeout(() => {
            if (!document.activeElement.classList.contains('autocomplete-list__item') && document.activeElement != document.getElementById('search__input')) {
                autocomplete.classList.remove('active')
            }
        }, 100)
    })

    // Show autocomplete
    document.getElementById('search__input').addEventListener('focus', function () {
        if (autocomplete.querySelector('.autocomplete-list__item') != null) {
            autocomplete.classList.add('active')
        }
    })

    // FAQs across the website
    if (document.querySelector('.faq')) {
        const faqs = document.querySelectorAll('.faq')
        for (let i = 0; i < faqs.length; i++) {
            faqs[i].addEventListener('click', function (e) {
                this.classList.toggle('faq--active')
            })
        }
    }
    if (document.querySelectorAll('[data-unlock]').length > 0) {
        document.querySelectorAll('[data-unlock]').forEach(unlock => unlock.addEventListener('click', function () {
            var modal = document.querySelector('[data-popup="free-download"]')
            var title = modal.querySelector('[data-download-title]')
            var download_id = modal.querySelector('input[name="download_id"]')

            modal.classList.add('active')
            title.innerHTML = unlock.querySelector('[data-download-title]').innerHTML

            download_id.value = unlock.dataset.unlock

            var code = document.querySelector('input[name="code"]')
            code.parentNode.classList.remove('error')
        }))
    }

    if (document.querySelector('[data-submit-form]')) {
        document.querySelector('[data-submit-form]').addEventListener('click', function () {
            var code = document.querySelector('input[name="code"]')
            var download_id = document.querySelector('input[name="download_id"]')

            if (code.value == '') {
                code.parentNode.classList.add('error')
            } else {
                code.parentNode.classList.remove('error')
                let formData = new FormData()

                formData.append('download_id', download_id.value)
                formData.append('code', code.value)

                fetch("/scripts/free-downloads.php", {
                    method: "POST",
                    body: formData
                }).then(res => res.json()).then(data => {
                    if (document.getElementById('code-error')) {
                        document.getElementById('code-error').remove()
                    }
                    if (data.success == 0) {
                        document.querySelector('[data-popup="free-download"] .reset--list').insertAdjacentHTML("beforeend", `<div class="error" id="code-error">"${code.value}" is not a valid code. Please try again.</div>`)
                    } else {
                        var link = document.createElement("a")
                        link.setAttribute('download', '')
                        link.href = data.file
                        document.body.appendChild(link)
                        link.click()
                        link.remove()

                        code.value = ''
                        document.querySelector('[data-popup="free-download"]').classList.remove('active')
                    }
                })
            }
        })
    }


    // Sticky basket
    if (document.querySelector('[data-modal="basket"]')) {
        stickyBasket()
    }
})()

function number_format(number, decimalPlaces) {
    decimalPlaces = decimalPlaces || 2
    return parseFloat(number).toLocaleString('en-GB', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })
}

function stickyBasket() {
    var basketModal = document.querySelector('[data-modal="basket"]')
    var basketToggle = document.querySelector('[data-sticky-basket]')
    var closeBasketToggle = document.querySelector('[data-close-basket]')

    basketToggle.addEventListener('click', function (e) {
        basketModal.classList.toggle('active')

        if (basketModal.classList.contains('active')) {
            updateStickyBasketItems()
        }
    })

    closeBasketToggle.addEventListener('click', function () {
        basketModal.classList.toggle('active')
    })

    document.querySelector('.modal__overlay[data-prompt="basket"]').addEventListener('click', function () {
        basketModal.classList.remove('active')
    })
}

function updateStickyBasketItems() {
    let formData = new FormData()
    formData.append("include_products", true)
    formData.append("action", null)

    fetch("/scripts/basket-manager.php", {
        method: "POST",
        body: formData
    }).then(res => res.json()).then(data => {
        var container = document.querySelector('[data-sticky-products]')
        var savedContainer = document.querySelector('[data-sticky-saved-products]')
        var subtotal = document.querySelector('[data-sticky-subtotal]')

        container.innerHTML = savedContainer.innerHTML = ''

        data.products.forEach(product => {
            var pr = document.createElement('li')
            pr.classList.add('modal__list-item')

            pr.innerHTML = `<a href="${product.product.url}" title="View product details" class="modal__list-item__link">
                <div class="modal__list-item__title"><span>${product.quantity}x</span> ${product.product.title} </div>
                <div class="modal__list-item__details">
                    <div>&pound;${number_format(product.subtotal)}</div>
                </div>
            </a>`

            container.appendChild(pr)
        })

        data.saved_products.forEach(product => {
            var pr = document.createElement('li')
            pr.classList.add('modal__list-item')

            pr.innerHTML = `<div class="modal__list-item__link">
                <a href="${product.product.url}" title="View product details" class="modal__list-item__title">${product.quantity} x ${product.product.title} </a>
                <div class="modal__list-item__details">
                    <button class="button button--plain" data-move-sticky="${product.unique_id}">Add +</button>
                </div>
            </div>`

            savedContainer.appendChild(pr)
        })

        subtotal.innerHTML = number_format(data.totals.subtotal)

        if (document.querySelector('.header__nav__action__count.hnac--basket')) {
            document.querySelector('.header__nav__action__count.hnac--basket').innerHTML = data.totals.total_products
        } else {
            var basketNavCount = document.createElement('span')
            basketNavCount.classList.add('header__nav__action__count', 'hnac--basket')
            basketNavCount.innerHTML = data.totals.total_products

            document.querySelector('[data-nav-basket]').querySelector('.header__nav__action__label').appendChild(basketNavCount)
        }

        if (document.querySelector('[data-sticky-quantity]')) {
            document.querySelector('[data-sticky-quantity]').innerHTML = data.totals.total_products
        } else {
            fetch("/scripts/sticky-basket-nav.php", {
                method: "POST"
            }).then(res => res.json()).then(data => {
                document.querySelector('body').insertAdjacentHTML("beforeend", data.content)
                setTimeout(stickyBasket, 500)
            })
        }

        var moveSavedItems = savedContainer.querySelectorAll('[data-move-sticky]')

        if (moveSavedItems.length > 0) {
            moveSavedItems.forEach(moveSavedItem => moveSavedItem.addEventListener('click', function () {
                var saved_basket_item_reference = moveSavedItem.getAttribute('data-move-sticky')

                let formData = new FormData()
                formData.append("saved_basket_item_reference", saved_basket_item_reference)
                formData.append("action", "move-to-basket")

                fetch("/scripts/basket-manager.php", {
                    method: "POST",
                    body: formData
                }).then(res => res.json()).then(data => {
                    updateStickyBasketItems()

                    document.querySelector('[data-saved-item="' + saved_basket_item_reference + '"]').remove()

                    if (document.querySelectorAll('[data-saved-item]').length == 0) {
                        document.querySelector('[data-stick-saved-items]').remove()
                    }
                })
            }))
        }
    })
}

document.querySelector('#products-splide1') && new Splide('#products-splide1', {
    type: 'loop',
    rewind: true,
    focus: 0,
    pagination: false,
    perPage: 3,
    omitEnd: true,
    autoplay: true,
    interval: 3000,
    lazyload: 'nearby'
}).mount();

document.querySelector('#products-splide2') && new Splide('#products-splide2', {
    type: 'loop',
    rewind: true,
    focus: 0,
    pagination: false,
    perPage: 3,
    omitEnd: true,
    autoplay: true,
    interval: 3000,
    lazyload: 'nearby'
}).mount();

document.querySelector('#products-splide3') && new Splide('#products-splide3', {
    type: 'loop',
    rewind: true,
    focus: 0,
    pagination: false,
    perPage: 3,
    omitEnd: true,
    autoplay: true,
    interval: 3000,
    lazyload: 'nearby'
}).mount();


document.querySelector('#reviews-splide') && new Splide('#reviews-splide', {
    type: 'loop',
    rewind: true,
    focus: 0,
    pagination: false,
    perPage: 1,
    omitEnd: true,
    autoplay: true
}).mount();


document.querySelector('#programmes-splide') && new Splide('#programmes-splide', {
    type: 'loop',
    rewind: true,
    focus: 0,
    pagination: false,
    perPage: 3,
    omitEnd: true,
    autoplay: true,
    interval: 3000,
    lazyload: 'nearby'
}).mount();